// extracted by mini-css-extract-plugin
export default {"block":"Be","select":"Ce","empty":"De","open":"Ee","error":"Fe","options":"Ge","selectActive":"He","ornament":"Ie"};